import React from "react";
import "../inward-styles.css";

const StockByWarehouse = ({ data }: { data: any[] }) => {
  return (
    <div className="rounded-lg border bg-white shadow-sm flex flex-col">
      <div className="p-6 pb-3 flex items-center justify-between">
        <h3 className="text-base font-semibold">Stock by Warehouse</h3>
        <span className="text-xs text-muted-foreground">
          {data.length} warehouses
        </span>
      </div>

      <div className="overflow-y-auto" style={{ maxHeight: "500px" }}>
        <div className="px-6 pb-6 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {data.map((w) => (
            <div
              key={w?.warehouse_code}
              id={`warehouse-inventory-warehouse-card-${w?.warehouse_code}`}
              className="rounded-lg border p-4"
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex flex-col gap-1">
                  <div className="text-xs md:text-sm font-semibold">
                    {w?.warehouse_name}
                  </div>
                  <div className="text-xs">{w?.warehouse_code}</div>
                </div>

                <span className="text-xs border px-2 py-0.5 rounded shrink-0">
                  {w?.warehouse_city}
                </span>
              </div>

              <p className="text-lg md:text-2xl font-bold">
                {w?.stock?.toLocaleString()}
              </p>
              <p className="text-xs text-muted-foreground">units in stock</p>

              <div className="mt-3 pt-3 border-t grid grid-cols-2 gap-2 text-xs">
                <div>
                  <p className="text-warning font-bold">
                    {(w?.pending_outwards ?? 0).toLocaleString()}
                  </p>
                  <p className="text-muted-foreground">Pending Outwards</p>
                </div>
                <div>
                  <p className="text-primary font-bold">
                    {(w?.in_transit ?? 0).toLocaleString()}
                  </p>
                  <p className="text-muted-foreground">In Transit</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StockByWarehouse;
